import React from 'react';
import { motion } from 'framer-motion';
import { Section, CHECKOUT_URL, PRICE_USD, PRICE_USD_VALUE, PRICE_USD_FULL, PRICE_USD_NEXT } from './Shared';
import { trackPixelEvent } from '../utils/metaPixel';
export const Pricing = () => <Section id="pricing" glow className="bg-brand-paper/70 rounded-sm my-12 border border-brand-gold/40" data-id="element-208" data-mp="2oi7g9inhxoyj">
    <div className="text-center mb-10 pt-10" data-id="element-209" data-mp="2jk5xkytzfrnl">
      <span className="inline-block border border-brand-gold/60 text-brand-goldDark font-seal text-[10px] md:text-xs uppercase tracking-seal px-4 py-1.5 rounded-sm mb-6" data-id="element-210" data-mp="1vts20yc6vao9">
        Oferta de lanzamiento
      </span>
      <h2 className="text-3xl md:text-5xl font-display font-bold text-brand-purpleDark" data-id="element-211" data-mp="25shn0zzdtb8q">
        Tu <span className="headline-shine" data-id="element-212" data-mp="20slgou37p7q0">Mega Pack Chi Kung</span>
      </h2>
      <p className="text-brand-text/70 mt-4 text-sm md:text-base" data-id="element-213" data-mp="3h7ed8d7ay6ho">
        El precio de lanzamiento cierra pronto. Después sube a {PRICE_USD_NEXT}.
      </p>
    </div>

    <div className="max-w-2xl mx-auto" data-id="element-214" data-mp="3c81rxww2x7h7">
      <div className="relative rounded-sm" data-id="element-215" data-mp="3vzp5xj5hic9j">
        <span className="glow-frame" aria-hidden="true" data-id="element-216" data-mp="3vynlio2kwdf5" />
        <div className="relative z-[1] w-full text-left rounded-sm p-6 md:p-8 bg-brand-paper border border-brand-purpleDark/10" data-id="element-217" data-mp="4svvrpspr2sv">
          <p className="font-seal text-[10px] uppercase tracking-seal text-brand-goldDark mb-4" data-id="element-218" data-mp="9ta1h16ue0nq">
            El sistema más completo
          </p>

          <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-219" data-mp="eoz79m9ggdsh">
            <div className="min-w-0" data-id="element-220" data-mp="3d74i4g4n6xcl">
              <h3 className="font-display font-bold text-xl md:text-2xl text-brand-purpleDark leading-tight" data-id="element-221" data-mp="3i790kbp4225g">
                Mega Pack Chi Kung
              </h3>
              <p className="text-sm text-brand-muted mt-1.5" data-id="element-222" data-mp="3n5ak0xqg83hg">
                3 tomos + 6 bonus · Más de 190 páginas
              </p>
              <p className="text-sm text-brand-text/80 mt-3 max-w-sm" data-id="element-223" data-mp="2uj97v688o1o8">
                El sistema integral de sesiones prediseñadas y protección
                energética para el terapeuta profesional.
              </p>
            </div>

            <div className="shrink-0 border-t border-brand-gold/30 pt-5 text-center sm:border-t-0 sm:border-l sm:pt-0 sm:pl-6 sm:text-right" data-id="element-224" data-mp="2rf1ue22t9i7b">
              <p className="text-sm text-brand-muted line-through leading-none" data-id="element-225" data-mp="316ehyhhktm7j">
                {PRICE_USD_FULL}
              </p>
              <p className="font-display font-bold text-4xl md:text-5xl leading-none mt-2 text-brand-purpleDark" data-id="element-226" data-mp="2w8w9stbdvb0l">
                {PRICE_USD}
              </p>
              <p className="text-xs text-brand-muted mt-3 max-w-[15rem] mx-auto sm:mx-0 leading-relaxed" data-id="element-227" data-mp="23j5re82pxmyo">
                Pago único · El valor cambia a tu moneda local
              </p>
            </div>
          </div>
        </div>
      </div>

      <motion.a href={CHECKOUT_URL} onClick={() => trackPixelEvent('InitiateCheckout', {
      content_name: 'Mega Pack Chi Kung',
      value: PRICE_USD_VALUE,
      currency: 'USD'
    })} whileHover={{
      scale: 1.015
    }} whileTap={{
      scale: 0.985
    }} className="mt-6 w-full inline-flex items-center justify-center px-6 py-5 text-base md:text-lg font-semibold uppercase tracking-wide text-brand-surface purple-gradient-bg rounded-sm ring-1 ring-brand-goldLight/50 animate-glow-pulse relative overflow-hidden cta-shimmer" data-id="element-228" data-mp="2dgaeca4e1mgj">
        <span className="relative z-10" data-id="element-229" data-mp="3nhfuloclr8hy">Quiero mi Mega Pack — {PRICE_USD}</span>
      </motion.a>

      <p className="text-center text-xs md:text-sm text-brand-muted pt-5" data-id="element-230" data-mp="3rihxqg9n44p7">
        Garantía de 7 días · Descarga inmediata · Pago seguro · Tarjeta
      </p>
    </div>
  </Section>;